import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { AgreementsService } from "../../../_services/agreements.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { UsedCarAgreement } from "../../../_models/used-cars/usedcaragreement";
import { ServiceOffer } from "../../../_models/serviceoffer";
import { ServiceAddon } from "../../../_models/serviceaddon";
import { StatisticsService } from '../../../_services/statistics.service';
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Observable } from "rxjs";
import {
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { ExtendOfferOption, ExtendOption } from "app/_models/extendOffer";
import { Car } from "app/_models";
import { DealersService } from "app/_services/dealers.service";
import { MatrixCalculatorService } from "app/_services/matrix/matrix-calculator.service";
import { UserService } from "app/_services";
import { MatrixCarService } from "app/_services/matrix/matrix-cars.service";
import { Dealer } from "app/_models/dealer";
// import { SelectedOptions } from "app/_models/used-cars/matrix-price";

@Component({
  selector: "app-used-cars-calculator",
  templateUrl: "./calculator.component.html",
  providers: [
    AgreementsService,
    CustomersService,
    DealersService,
    MatrixCalculatorService,
    MatrixCarService,
    ServiceOffersService,
    ServiceAddonsService,
    StatisticsService,
  ],
})
export class UsedCarsCalculatorComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private customer: Customer;
  public hasResponded: boolean = false;
  public usedcar: Car;

  public showDetails: boolean = false;
  public completedData;
  isActive: number | null = null;

  private regnr: string = "";
  private useCarId: string = "";
  private dealercalc: boolean;
  private customerid: string = "";
  private mauticId: string = "";
  private dealer: Dealer;
  private errorMessage: string = "";
  private isLoading: boolean = true;
  private calcStartupCost: boolean = true;

  private extendOptions: ExtendOfferOption[] = [];
  public kmSelected: number = 15000;
  public yearSelected: string = "5";

  public kmLastSelected: number = 15000;
  public yearLastSelected: string = "5";

  private mauticCustomer: any;
  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number = 0;
  public agree: UsedCarAgreement;
  private subscription: Subscription;
  private service_price: number;
  public firstOptions: any;
  public options: any = {
    yearStep: [1],
    kmStep: [],
  };
  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  private showSearchByReg: boolean = true;
  public dealerid: string = "";
  public contactDealerAlert: boolean = false;
  public cantCalculateModalRef: NgbModalRef;
  @ViewChild("cantCalculateModalTemplate") modalCantCalculate: TemplateRef<any>;

  constructor(
    toasterService: ToasterService,
    private activatedRoute: ActivatedRoute,
    private agreementsService: AgreementsService,
    private customersService: CustomersService,
    private dealerService: DealersService,
    private matrixCalculatorService: MatrixCalculatorService,
    private matrixCarService: MatrixCarService,
    private modalService: NgbModal,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private statisticsService: StatisticsService,
    private userService: UserService
  ) {
    this.toasterService = toasterService;
  }

  ngOnInit() {
    this.isLoading = true;
    var getIsadmin;
    var did;
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        getIsadmin = this.userService.getIsadmin();
        this.mauticId = param["id"];
        if (param["dealerId"] != null) {
          this.dealerid = param["dealerId"];
        }
        this.customerid = param["custId"];
        this.regnr = param["regnr"];
        
        this.dealercalc = param["dealercalc"] == "true";
        if (param["regsearch"] && param["regsearch"] == "false") {
          this.showSearchByReg = false;
        }

        this.getCustomer(this.mauticId, this.customerid, this.dealerid).subscribe(
          (c) => {
            this.customer = c;
            this.useCarId = c.usedCarId;
            if (c.regnr != null && c.regnr != "") {
              this.regnr = c.regnr.toString();
            }
            
            if ((this.customer.regnr == null || this.customer.regnr == "") && (this.regnr != null && this.regnr != "")) {
              this.customer.regnr = this.regnr;
              this.customersService.update(this.customer);
            }

            if (!this.customerid) { this.customerid = this.customer._id };
            this.dealerid = did = this.dealerid != "" ? this.dealerid : c.dealer[0].toString();
          },
          (e) => {
            this.errorMessage = e;
          },
          () => {
            let statisticEvent: StatisticEvent = new StatisticEvent();
            statisticEvent.customer = this.customer._id;
            statisticEvent.event = "used_car_lp_visit";
            this.payment_method = this.customer.dealer[0].payment_method;
            this.statisticsService
              .sendEvent(statisticEvent)
              .subscribe(
                /* happy path */ r => { console.log('used-car landingpage visit event tracked'); },
                /* error path */ e => { this.errorMessage = e });
            this.matrixCarService.getCar(this.useCarId).subscribe(
              (c) => {
                this.usedcar = c;
                this.carname =
                  c.carmake + " " + c.carmodel + " " + c.carversion;
              },
              (e) => (this.errorMessage = e)
            );
            this.dealerService.get(did).subscribe(
              (d) => {
                this.payment_method = d.payment_method;
                this.dealer = d;
              },
              (e) => (this.errorMessage = e),
              () =>
                this.customersService
                  .queryFromMautic(217, this.dealerid, {
                    attributeName: "regnr",
                    attributeValue: this.regnr,
                  })
                  .subscribe(
                    (customer) => {
                      this.mauticCustomer = customer;
                      this.isLoading = false;
                      this.isCarTooOld(this.mauticCustomer.firstreg);
                    },
                    (e) => (this.errorMessage = e),
                    () =>
                      this.matrixCalculatorService
                        .getAgreementLengths({
                          carId: this.useCarId,
                          agreementStartDate: new Date(
                            this.mauticCustomer.lastServiceDate
                          ),
                          firstreg: new Date(this.mauticCustomer.firstreg),
                          maxKms: this.dealer.maxKms,
                          maxLength: this.dealer.maxYears,
                          selectedKms: this.kmSelected,
                          carKms: this.mauticCustomer.carkms,
                          showPartialYears: true,
                          untilDate: new Date(
                            this.mauticCustomer.lastServiceDate
                          ),
                          currentAgreementKms: this.mauticCustomer.carkms,
                        })
                        .subscribe(
                          /* happy path */ (p) => {
                            this.options.yearStep = p.ages;
                            this.firstOptions = [...this.options.yearStep];
                            this.yearSelected = p.ages.length
                              ? p.ages[p.ages.length - 1].toString()
                              : null;
                          },
                          /* error path */ (e) => {
                            this.errorMessage = e;
                          },
                          () => this.updateAvailableKms()
                        )
                  )
            );

            this.serviceAddonsService
              .getDealer(this.dealerid, "usedcars")
              .subscribe(
                /* happy path */ (p) => (this.serviceaddons = p),
                /* error path */ (e) => (this.errorMessage = e),
                /* onComplete */ () => {
                  for (var i = 0; i < this.serviceaddons.length; i++) {
                    this.serviceaddons[i].selected = false;
                  }
                }
              );
          }
        );
      }
    );
  }

  updateUpsaleOptions() {
    this.matrixCalculatorService
      .getUpsaleOptions(
        this.useCarId,
        this.kmSelected,
        new Date(this.mauticCustomer.lastServiceDate),
        new Date(this.mauticCustomer.firstreg),
        this.mauticCustomer.carkms
      )
      .subscribe(
        /* happy path */ (p) => {
          this.extendOptions = Object.keys(p).map((option) => {
            const price = p[option].monthlyPrice;
            const agreementLength = p[option].agreementLength;

            if (
              option === "cheapest" &&
              this.dealer.usedCarPeriodCheapestEnabled
            )
              return {
                shortTitle: "Billigst",
                title: agreementLength.includes("år")
                  ? agreementLength
                  : `${agreementLength} års aftale.`,
                subtitle: "BEREGNET YDELSE PR. MANED",
                price,
                value: ExtendOption.CHEAPEST,
                selected: false,
                agreementLength,
              };
            if (option === "longest" && this.dealer.usedCarPeriodLongestEnabled)
              return {
                shortTitle: "Længst",
                title: agreementLength.includes("år")
                  ? `${agreementLength} aftale`
                  : `${agreementLength} års aftale.`,
                subtitle: "BEREGNET YDELSE PR. MANED",
                price,
                value: ExtendOption.LONGEST,
                selected: false,
                agreementLength,
              };
            if (
              option === "faster" &&
              this.dealer.usedCarPeriodExtraYearEnabled
            )
              return {
                shortTitle: "1 år mere",
                title: `Forlæng aftalen med ${agreementLength} år.`,
                subtitle: "BEREGNET YDELSE PR. MANED",
                price,
                value: ExtendOption.ONE_YEAR,
                selected: false,
                agreementLength,
              };
          });
        },
        /* error path */ (e) => {
          this.errorMessage = e;
        }
      );
  }

  updateAvailableYears() {
    this.options.yearStep = [];
    this.matrixCalculatorService
      .getAgreementLengths({
        carId: this.useCarId,
        agreementStartDate: new Date(this.mauticCustomer.lastServiceDate),
        firstreg: new Date(this.mauticCustomer.firstreg),
        maxKms: this.dealer.maxKms,
        maxLength: this.dealer.maxYears,
        selectedKms: this.kmSelected,
        carKms: this.mauticCustomer.carkms,
        showPartialYears: true,
        untilDate: new Date(this.mauticCustomer.lastServiceDate),
        currentAgreementKms: this.mauticCustomer.carkms,
      })
      .subscribe(
        /* happy path */ (p) => {
          this.options.yearStep = p.ages;
          this.firstOptions = this.options.yearStep;
          if (p.ages.length)
            this.yearSelected = p.ages.find(
              (length) => `${length}` === this.yearSelected
            )
              ? this.yearSelected
              : `${p.ages[p.ages.length - 1]}`;
          this.updateUpsaleOptions();
        },
        /* error path */ (e) => {
          this.errorMessage = e;
        },
        () => this.calculatePrice()
      );
  }

  updateAvailableKms() {
    this.options.kmStep = [];
    this.matrixCalculatorService
      .getAgreementKms({
        carId: this.useCarId,
        agreementStartDate: new Date(this.mauticCustomer.lastServiceDate),
        firstreg: new Date(this.mauticCustomer.firstreg),
        maxKms: this.dealer.maxKms,
        carKms: this.mauticCustomer.carkms,
        showPartialYears: true,
        untilDate: new Date(this.mauticCustomer.lastServiceDate),
        currentAgreementKms: this.mauticCustomer.carkms,
        maxLength: this.dealer.maxYears,
      })
      .subscribe(
        (p) => {
          this.options.kmStep = p.kms;
          if (p.kms.length)
            this.kmSelected = p.kms.find(
              (kms) => Number(kms) === Number(this.kmSelected)
            )
              ? this.kmSelected
              : p.kms[0];
          if (
            this.options.kmStep.length <= 1 &&
            this.contactDealerAlert == false
          ) {
            this.calculatedPrice = 0;
            this.showCantCalculateModal();
            this.contactDealerAlert = true;
          }
          this.updateUpsaleOptions();
        },
        (e) => (this.errorMessage = e),
        () => this.calculatePrice()
      );
  }

  selectExtendOption(event: ExtendOfferOption, index: number) {
    this.isActive = index;
    this.extendOptions = this.extendOptions.map((option) => ({
      ...option,
      selected: event.selected ? false : event.value === option.value,
    }));
    switch (event.value) {
      case ExtendOption.ONE_YEAR:
        const index = this.options.yearStep.findIndex(
          (op) => `${op}` === `${this.yearSelected}`
        );
        if (
          this.options.yearStep.length > 1 &&
          index + 1 <= this.options.yearStep.length - 1
        ) {
          this.yearSelected = this.options.yearStep[index + 1];
          this.updateAvailableKms();
        }
        break;
      case ExtendOption.CHEAPEST:
        if (
          !this.options.yearStep!.some(
            (item) => String(item) === event.agreementLength
          )
        ) {
          this.options.yearStep.push(event.agreementLength);
        }
        this.yearSelected = event.agreementLength;
        this.updateAvailableKms();
        break;
      case ExtendOption.LONGEST:
        if (
          !this.options.yearStep!.some(
            (item) => String(item) === event.agreementLength
          )
        ) {
          this.options.yearStep.push(event.agreementLength);
        }
        this.yearSelected = event.agreementLength;
        this.updateAvailableKms();
        break;
    }
  }

  restoreExtendOptions() {
    this.extendOptions = this.extendOptions.map((option) => ({
      ...option,
      selected: false,
    }));
    this.calculatePrice();
  }

  updateSelectedKms(event: number) {
    this.options.yearStep = [...this.firstOptions];
    this.kmSelected = event;
    this.updateAvailableYears();
  }

  updateSelectedYear(event: string) {
    this.isActive = -1;
    this.options.yearStep = [...this.firstOptions];
    this.yearSelected = event;
    this.updateAvailableKms();
  }

  isCarTooOld(reg: number) {
    var yearTooOld = new Date().getFullYear() - 10;
    var regYear = new Date(reg).getFullYear();
    //alert(firstreg.getFullYear());
    if (yearTooOld >= regYear && this.contactDealerAlert == false) {
      this.calculatedPrice = 0;
      this.showCantCalculateModal();
      this.contactDealerAlert = true;
    }
  }

  calculatePrice() {
    let statisticEvent: StatisticEvent = new StatisticEvent();
    statisticEvent.customer = this.customer._id;
    statisticEvent.event = "used_car_lp_calculator_date";
    this.statisticsService
      .sendEvent(statisticEvent)
      .subscribe(
	      /* happy path */ r => { console.log('used car landingpage calculator event tracked'); },
	      /* error path */ e => { this.errorMessage = e; this.isLoading = false; });
    this.matrixCalculatorService
      .getUsedCarMonthlyPrice(
        this.useCarId,
        this.yearSelected,
        this.kmSelected,
        new Date(this.mauticCustomer.lastServiceDate),
        new Date(this.mauticCustomer.firstreg),
        this.mauticCustomer.carkms
      )
      .subscribe(
        /* happy path */ (p) => {
          this.calculatedPrice = p.monthlyPrice;
          this.completedData = p;
        },
        /* error path */ (e) => {
          this.errorMessage = e;
        },
        /* onComplete */
        () => {
          let newPrice: number;

          newPrice = this.calculatedPrice;
          this.serviceaddonslist = [];
          for (var i = 0; i < this.serviceaddons.length; i++) {
            if (this.serviceaddons[i].selected) {
              newPrice += this.serviceaddons[i].price;
              this.serviceaddonslist.push(this.serviceaddons[i]);
            }
          }
          this.calculatedPrice = newPrice;
        }
      );
  }

  monthDiff(d1, d2): number {
    return this.getMonthsBetween(d1, d2, false);
  }

  getMonthsBetween(date1, date2, roundUpFractionalMonths) {
    //Months will be calculated between start and end dates.
    //Make sure start date is less than end date.
    //But remember if the difference should be negative.
    var startDate = date1;
    var endDate = date2;
    var inverse = false;
    if (date1 > date2) {
      startDate = date2;
      endDate = date1;
      inverse = true;
    }

    //Calculate the differences between the start and end dates
    var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    var monthsDifference = endDate.getMonth() - startDate.getMonth();
    var daysDifference = endDate.getDate() - startDate.getDate();

    var monthCorrection = 0;
    //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
    //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
    if (roundUpFractionalMonths === true && daysDifference > 0) {
      monthCorrection = 1;
    }
    //If the day difference between the 2 months is negative, the last month is not a whole month.
    else if (roundUpFractionalMonths !== true && daysDifference < 0) {
      monthCorrection = -1;
    }

    return (
      (inverse ? -1 : 1) *
      (yearsDifference * 12 + monthsDifference + monthCorrection)
    );
  }
  showCantCalculateModal(): void {
    this.cantCalculateModalRef = this.modalService.open(
      this.modalCantCalculate
    );
  }
  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }

  getCustomer(mauticId: string, customerId: string, dealerId: string): Observable<Customer> {
    if (mauticId != null) {
      return this.customersService.getCustomerByMauticIdent(mauticId, dealerId)
    }
    else {
      return this.customersService.get(customerId);
    }
  }

  gotoCheckout(): void {
    const newItem: Partial<UsedCarAgreement> = {
      car: [this.usedcar],
      customer: this.customerid,
      years: this.yearSelected + "",
      km: this.kmSelected + "",
      addons: this.serviceaddonslist,
      price: this.calculatedPrice,
      service_price: this.service_price,
      payout: this.startupPrice,
      actualkm: this.mauticCustomer.carkms,
      lastservice: this.mauticCustomer.agreementStartDate,
      customerAccept: this.mauticCustomer.micar_agreement_acceptanc,
    };
    sessionStorage.setItem("usedCarsAgree", JSON.stringify(newItem));
    sessionStorage.setItem("completedData", JSON.stringify(this.completedData));

    if (this.serviceaddons.length > 0) {
      top.window.location.href =
        "/#/used-cars/order-flow/additional-products/" +
        this.customerid +
        "?regsearch=" +
        (this.showSearchByReg ? "true" : "false") +
        (this.dealercalc ? "&dealercalc=true" : "");
    } else {
      top.window.location.href =
        "/#/used-cars/order-flow/checkout/" +
        this.customerid +
        "?regsearch=" +
        (this.showSearchByReg ? "true" : "false") +
        (this.dealercalc ? "&dealercalc=true" : "");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/usedcars/oder-flow/calculator.component.ts